var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14C16.5773 14 18.6667 11.9107 18.6667 9.33335C18.6667 6.75602 16.5773 4.66669 14 4.66669C11.4227 4.66669 9.33334 6.75602 9.33334 9.33335C9.33334 11.9107 11.4227 14 14 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 22.1667V23.3334C23.3333 23.6428 23.2104 23.9395 22.9916 24.1583C22.7728 24.3771 22.4761 24.5 22.1667 24.5H5.83332C5.5239 24.5 5.22716 24.3771 5.00837 24.1583C4.78957 23.9395 4.66666 23.6428 4.66666 23.3334V22.1667C4.66666 20.3102 5.40415 18.5297 6.71691 17.2169C8.02966 15.9042 9.81014 15.1667 11.6667 15.1667H16.3333C18.1898 15.1667 19.9703 15.9042 21.2831 17.2169C22.5958 18.5297 23.3333 20.3102 23.3333 22.1667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.641d8d771080e2916029aa371b718bfe.svg";
export { ForwardRef as ReactComponent };